'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('./_tslib-15827112.js');
require('./getScript.js');
require('axios');
require('./LoginConsent.js');
require('./AuthApi.js');
var Auth = require('./Auth.js');

var FBAuth = /** @class */ (function (_super) {
    _tslib.__extends(FBAuth, _super);
    function FBAuth(_a) {
        var loginFacebookApiKey = _a.loginFacebookApiKey, props = _tslib.__rest(_a, ["loginFacebookApiKey"]);
        var _this = _super.call(this, _tslib.__assign({}, props)) || this;
        _this._FBInit = function () {
            return new Promise(function (resolve, reject) {
                //@ts-ignore
                FB.init({
                    appId: _this.loginFacebookApiKey,
                    version: 'v3.0' // or v2.1, v2.2, v2.3, ...
                });
                resolve();
            });
        };
        _this.LoadFBSdk = function () {
            return _this.LoadSdk('https://connect.facebook.net/en_US/sdk.js');
        };
        _this.SignIn = function () {
            return _this._FBInit()
                .then(_this._loginFacebook)
                .then(_this._FBLoginCallback);
        };
        _this._loginFacebook = function () {
            return new Promise(function (resolve, reject) {
                //@ts-ignore
                FB.login(resolve, { scope: 'public_profile,email' });
            });
        };
        _this._FBLoginCallback = function (response) {
            console.log(response);
            if (response.status === 'connected') {
                // Logged into your app and Facebook.
                //@ts-ignore
                var authResponse = FB.getAuthResponse();
                var params = { Code: authResponse.accessToken };
                return _this.$AuthApi.LoginFacebook(params)
                    .then(function (response) { return (_this._authCallback(response.data, 'facebook', response.status === 201)); })
                    .catch(console.error);
            }
            else {
                if (response.status !== undefined)
                    return Promise.reject(new Error('There was an error'));
            }
        };
        _this.loginFacebookApiKey = loginFacebookApiKey;
        return _this;
    }
    return FBAuth;
}(Auth.default));

exports.default = FBAuth;
//# sourceMappingURL=FBAuth.js.map
